<template>
  <div
    class="incoming-tender-list-row incoming-tender-list-row_breakdown incoming-tender-list-row_breakdown-value incoming-tender-list-row_company"
    @click="$emit('toggle-company')"
  >
    <div class="tender-list-cell tender-list-cell_numbering">
      {{ parentRowIndex + 1 }}.{{ index }}
    </div>
    <div class="tender-list-cell tender-list-cell_company">
      <ArrowIcon class="pointer" :class="{ 'turn-over': isCompanyOpen }" />
      <span>{{ companyName }}</span>
    </div>
    <div v-for="i in countOfEmptyCells" :key="i" class="tender-list-cell tender-list-cell_light" />
  </div>
</template>

<script>
  import ArrowIcon from '@/assets/icons/chevron-down.svg';
  import {
    GENERAL_ESTIMATE_COLUMN_WIDTH,
    DEFAULT_COLUMN_WIDTH,
    WIDE_COLUMN_DELTA,
    STATIC_UNIT_QUANTITY_WIDTH,
  } from '@/containers/tender/tender-list/constants';

  export default {
    name: 'TenderListBreakdownRowCompany',
    components: {
      ArrowIcon,
    },
    props: {
      companyName: {
        type: String,
        required: true,
      },
      parentRowIndex: {
        type: Number,
        required: true,
      },
      openedCount: {
        type: Number,
        required: true,
      },
      offersCount: {
        type: Number,
        required: true,
      },
      isCompanyOpen: {
        type: Boolean,
        default: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    computed: {
      countOfEmptyCells() {
        return (
          this.openedCount * WIDE_COLUMN_DELTA +
          this.offersCount * DEFAULT_COLUMN_WIDTH +
          STATIC_UNIT_QUANTITY_WIDTH +
          GENERAL_ESTIMATE_COLUMN_WIDTH
        );
      },
    },
  };
</script>
